"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveGameData = exports.LoadGameData = exports.RefreshHouseData = exports.HouseData = exports.GameData = exports.Items = exports.Builders = void 0;
var seedrandom_1 = __importDefault(require("seedrandom"));
var _1 = require(".");
var enums_1 = require("./enums");
var url_1 = require("./lib/url");
var logger_1 = require("./logger");
exports.Builders = [
    enums_1.ITEM.Blueprint,
    enums_1.ITEM.Hammer,
    enums_1.ITEM.Drone,
    enums_1.ITEM.Builder,
    enums_1.ITEM.Mixer,
    enums_1.ITEM.RoboticArm,
    enums_1.ITEM.Printer,
    enums_1.ITEM.Crane,
    enums_1.ITEM.Robot,
    enums_1.ITEM.Ufo,
];
exports.Items = {
    moneyPerBrick: {
        name: "Money per brick",
        basePrice: 1000,
        coefficient: 1.18,
        imageName: "money.png",
    },
    bricksPerClick: {
        name: "Bricks per click",
        basePrice: 2000,
        coefficient: 1.75,
        imageName: "brick.png",
    },
    houseSize: {
        name: "House size",
        basePrice: 500,
        coefficient: 1.3,
        imageName: "house.png",
    },
    banker: {
        name: "Banker",
        basePrice: 1000,
        coefficient: 1.5,
        imageName: "banker.png",
    },
    bank: {
        name: "Bank",
        basePrice: 1000,
        coefficient: 1.5,
        imageName: "bank.png",
    },
    // builders
    blueprint: {
        name: "Blueprint",
        basePrice: 50,
        coefficient: 0,
        imageName: "blueprint.png",
        intervalSeconds: 10,
    },
    hammer: {
        name: "Hammer",
        basePrice: 0,
        coefficient: 0,
        imageName: "hammer.png",
        intervalSeconds: 9,
    },
    drone: {
        name: "Drone",
        basePrice: 0,
        coefficient: 0,
        imageName: "drone.png",
        intervalSeconds: 8,
    },
    builder: {
        name: "Builder",
        basePrice: 0,
        coefficient: 0,
        imageName: "builder.png",
        intervalSeconds: 7,
    },
    mixer: {
        name: "Mixer",
        basePrice: 0,
        coefficient: 0,
        imageName: "mixer.png",
        intervalSeconds: 6,
    },
    roboticArm: {
        name: "Robotic arm",
        basePrice: 0,
        coefficient: 0,
        imageName: "robotic-arm.png",
        intervalSeconds: 5,
    },
    printer: {
        name: "Printer",
        basePrice: 0,
        coefficient: 0,
        imageName: "printer.png",
        intervalSeconds: 4,
    },
    crane: {
        name: "Crane",
        basePrice: 0,
        coefficient: 0,
        imageName: "crane.png",
        intervalSeconds: 3,
    },
    robot: {
        name: "Robot",
        basePrice: 0,
        coefficient: 0,
        imageName: "robot.png",
        intervalSeconds: 2,
    },
    ufo: {
        name: "UFO",
        basePrice: 0,
        coefficient: 0,
        imageName: "ufo.png",
        intervalSeconds: 1,
    },
};
var builderCoeficient = 1.18; // builder coefficient start from this and decreases to 1.2
var minBuilderCoeficient = 1.07;
var builderCoeficientDecrement = (builderCoeficient - minBuilderCoeficient) / exports.Builders.length;
exports.Builders.forEach(function (builder, index) {
    exports.Items[builder].coefficient = builderCoeficient;
    builderCoeficient -= builderCoeficientDecrement; // decrease the coefficient for more expensive builders
    if (index === 0)
        return;
    var prevItem = exports.Builders[index - 1];
    exports.Items[builder].basePrice = Math.floor(exports.Items[prevItem].basePrice * Math.pow(exports.Items[prevItem].coefficient, 10));
});
logger_1.Logger.log(exports.Items);
var ColorThemes = [
    { brickColor: "#5e5e5e", skyColor: "#55d15a" },
    { brickColor: "#c44a4d", skyColor: "#ffdb31" },
    { brickColor: "#d1522a", skyColor: "#42abff" },
];
var BuildHouseData = function () {
    var hd = {
        bricksPerRow: 5,
        colorTheme: ColorThemes[Math.floor((0, seedrandom_1.default)(exports.GameData.seed).quick() * ColorThemes.length)],
        // calculated later
        rowsPerBlock: 0,
        xBlocks: 1,
        yBlocks: 1,
        totalBricks: 0,
        totalBlocks: 0,
    };
    hd.rowsPerBlock = hd.bricksPerRow * 2;
    for (var i = 1; i <= exports.GameData.itemLevel.houseSize; i++) {
        if (i % 2 !== 0) {
            hd.xBlocks++;
        }
        else {
            hd.yBlocks++;
        }
    }
    hd.totalBricks = hd.xBlocks * hd.bricksPerRow * hd.yBlocks * hd.rowsPerBlock + Math.floor((hd.yBlocks * hd.rowsPerBlock) / 2);
    hd.totalBlocks = hd.xBlocks * hd.yBlocks;
    return __assign({}, hd);
};
// in case loading game data fails, this value is already populated with default data
exports.GameData = {
    money: (0, url_1.getQueryString)("dontSaveDataIHBTestParam") == "true" && (0, url_1.getQueryString)("manyMoney") == "true" ? 900719900254740991 : 0,
    placedBricks: 0,
    lastOnlineMs: new Date().getTime(),
    seed: new Date().getTime().toString(),
    itemLevel: {
        // upgrades
        moneyPerBrick: 0,
        bricksPerClick: 0,
        houseSize: 0,
        bank: 0,
        banker: 0,
        // builders
        blueprint: 0,
        hammer: 0,
        drone: 0,
        builder: 0,
        mixer: 0,
        roboticArm: 0,
        printer: 0,
        crane: 0,
        robot: 0,
        ufo: 0,
    },
};
exports.HouseData = BuildHouseData();
var RefreshHouseData = function () {
    exports.HouseData = BuildHouseData();
};
exports.RefreshHouseData = RefreshHouseData;
var LoadGameData = function () { return __awaiter(void 0, void 0, void 0, function () {
    var fbData, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(_1.platform === "fb")) return [3 /*break*/, 5];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, window.FBInstant.player.getDataAsync(["IHB_data"])];
            case 2:
                fbData = _a.sent();
                console.log("FB data fetched", fbData);
                fbData = fbData["IHB_data"];
                if (!!fbData) {
                    console.log("Has FB data", fbData);
                    if (typeof fbData === "string") {
                        console.log("FB data is string, convert to JSON");
                        fbData = JSON.parse(fbData);
                    }
                    exports.GameData = fbData;
                    console.log("Loaded game data from Facebook", exports.GameData);
                }
                else {
                    console.log("Facebook doesn't have game data, starting game with initial data");
                }
                return [3 /*break*/, 4];
            case 3:
                e_1 = _a.sent();
                console.error("Failed to load FB Instant Games data", e_1);
                return [3 /*break*/, 4];
            case 4: return [3 /*break*/, 6];
            case 5:
                if (_1.platform === "crazygames") {
                    // data migration to v3 data module
                    if (localStorage.getItem("IHB_data")) {
                        window.CrazyGames.SDK.data.setItem("IHB_data", localStorage.getItem("IHB_data"));
                        localStorage.removeItem("IHB_data");
                        console.log("Migrated data to v3 data module");
                    }
                    if (window.CrazyGames.SDK.data.getItem("IHB_data")) {
                        exports.GameData = JSON.parse(window.CrazyGames.SDK.data.getItem("IHB_data"));
                        console.log("Loaded data from v3 data module", exports.GameData);
                    }
                    else {
                        console.log("No data in v3 data module");
                    }
                }
                else {
                    // yandex for example
                    if (localStorage.getItem("IHB_data")) {
                        exports.GameData = JSON.parse(localStorage.getItem("IHB_data"));
                    }
                }
                _a.label = 6;
            case 6:
                (0, exports.RefreshHouseData)();
                return [2 /*return*/];
        }
    });
}); };
exports.LoadGameData = LoadGameData;
var SaveGameData = function () {
    exports.GameData.lastOnlineMs = new Date().getTime();
    if (_1.platform === "fb") {
        window.FBInstant.player.setDataAsync({
            IHB_data: JSON.stringify(exports.GameData),
        });
    }
    else if (_1.platform === "crazygames") {
        if ((0, url_1.getQueryString)("dontSaveDataIHBTestParam") == "true")
            return;
        window.CrazyGames.SDK.data.setItem("IHB_data", JSON.stringify(exports.GameData));
    }
    else {
        // yandex for example
        if ((0, url_1.getQueryString)("dontSaveDataIHBTestParam") == "true")
            return;
        localStorage.setItem("IHB_data", JSON.stringify(exports.GameData));
    }
};
exports.SaveGameData = SaveGameData;
setInterval(exports.SaveGameData, 5000);
